import { store } from "./store/store.js";
import bankPrefixes from "@/helper/bank-prefixes";
import Vue from "vue";
export default {
  createCallback: function (rawCallback, paymentId, status) {
    if (rawCallback.split("?").length === 2) {
      if (rawCallback.split("?")[1] === "/")
        return rawCallback.slice(0, -1) + `&status=${status}`;
      return rawCallback + `&payId=${paymentId}&status=${status}`;
    } else if (rawCallback.split("?").length === 1) {
      return rawCallback + `?payId=${paymentId}&status=${status}`;
    } else {
      return rawCallback;
    }
  },
  //if the site id received from the sites api,
  //was not 1,2
  siteIdCondition() {
    return ![1, 2].includes(store.getters.getSiteId);
  },

  siteShowRatesCondition() {
    return store.getters.getSitesApiResult &&
      store.getters.getSitesApiResult.data
      ? store.getters.getSitesApiResult.data.settings.rate_display_to_shop
      : true;
  },

  //if the site id received from the sites api,
  //was not 5
  siteIdFiveCondition() {
    return ![5].includes(store.getters.getSiteId);
  },
  siteId17Condition() {
    return ![17].includes(store.getters.getSiteId);
  },
  onInfoPaste(evt, targetVariable) {
    let clipboardData = evt.clipboardData.getData("text");
    const result = clipboardData.match(/.{1,4}/g) ?? [];
    for (let index = 0; index < result.length; index++) {
      if (this.$data[targetVariable])
        this.$data[targetVariable][index].value = result[index];
    }
  },
  /**
   *
   * @param cardNumber
   * @returns {null|{svgAddress: string, prefix: string[], enName: string, faName: string}|{svgAddress: string, prefix: string[], enName: string, faName: string}|{svgAddress: string, prefix: string[], enName: string, faName: string}|{svgAddress: string, prefix: string[], enName: string, faName: string}|{svgAddress: string, prefix: string[], enName: string, faName: string}}
   */
  findBank(cardNumber) {
    const firstSixNums =
      cardNumber[0].value + cardNumber[1].value.toString().slice(0, 2);
    if (firstSixNums.length === 6) {
      for (const bank of bankPrefixes) {
        if (bank.prefix.includes(firstSixNums)) {
          return bank;
        }
      }
    }
    return null;
  },
  /**
   *
   * @param creditCardNumber {Array}
   * @returns {(boolean|string)[]|(boolean|*)[]}
   */
  checkWhatBank(creditCardNumber) {
    if (creditCardNumber.length > 1) {
      const firstSixNums =
        creditCardNumber[0].value +
        creditCardNumber[1].value.toString().slice(0, 2);
      switch (firstSixNums) {
        case "":
          return [false, ""];
        case "603799":
          return [true, require("@/assets/images/bankImages/bankmeli.png")];
        case "589210":
          return [true, require("@/assets/images/bankImages/sepah.png")];
        case "603769":
          return [true, require("@/assets/images/bankImages/saderat.png")];
        case "603770":
          return [true, require("@/assets/images/bankImages/keshavarzi.png")];
        case "628023":
          return [true, require("@/assets/images/bankImages/maskan.png")];
        case "622106":
          return [true, require("@/assets/images/bankImages/parsian.png")];
        case "502229":
          return [true, require("@/assets/images/bankImages/pasargad.png")];
        case "610433":
          return [true, require("@/assets/images/bankImages/bankmelat.png")];
        case "627353" || "585983":
          return [true, require("@/assets/images/bankImages/tejarat.png")];
        case "636214":
          return [true, require("@/assets/images/bankImages/ayandebank.png")];
        default:
          return [false, ""];
      }
    }
  },

  getBankName(creditCardNumber) {
    const firstSixNums =
      creditCardNumber[0].value +
      creditCardNumber[1].value.toString().slice(0, 2);
    switch (firstSixNums) {
      case "603799":
        return "ملی";
      case "589210":
        return "سپه";
      case "603769":
        return "صادرات";
      case "603770":
        return "کشاورزی";
      case "628023":
        return "مسکن";
      case "622106":
        return "پارسیان";
      case "502229":
        return "پاسارگاد";
      case "610433":
        return "ملت";
      case "627353":
        return "تجارت";
      case "636214":
        return "آینده";
      default:
        return "";
    }
  },

  validateCreditCardNumber(number) {
    let sum = 0;
    const numericList = number.split("");
    for (let index = 1; index <= numericList.length; index++) {
      //if it was the last number (since its position is always 16), it will multiply by 1 anyway in the loop but this also works.
      if (index === numericList.length) {
        sum = +numericList[index - 1] + sum;
        //if even number
      } else if (index % 2 === 0) {
        let result = numericList[index - 1] * 1;
        result = result > 9 ? result - 9 : result;
        sum = result + sum;
      } else {
        let result = numericList[index - 1] * 2;
        result = result > 9 ? result - 9 : result;
        sum = result + sum;
      }
    }
    if (numericList.length === 16) {
      return sum % 10 === 0;
    }
  },
  //only array sorting
  sortDesc(list) {
    if (list) return list.sort((x, y) => +x - +y);
  },
  /**
   * this function will set translated amounts to amount option value
   * only can translate values that are number of string seperated with , like = "2000,4000,6000"
   * @param value
   */
  translateMultiNumberStringForSelector(value) {
    let newOptions = {};
    // Add default option
    newOptions[0] = {
      value: null,
      text: Vue.prototype.$translate("selectTheTransactionAmount"),
    };
    const newData = value.split(",");
    const sortedEntries = this.sortDesc(newData);
    let amountText = "";
    for (let i = 0; i < sortedEntries.length; i++) {
      amountText = Vue.filter("commaSep")(sortedEntries[i]);
      newOptions[i + 1] = {
        value: sortedEntries[i],
        text: amountText + " " + Vue.prototype.$translate("toman") + " ",
      };
    }
    return newOptions;
  },
  /**
   * this function will set translated amounts to amount option value
   * only can translate values that are array of numbers , like = ["2000", "4000" , "6000"]
   * @param value
   */
  translateArrayForSelector(value) {
    let newOptions = {};
    // Add default option
    newOptions[0] = {
      value: null,
      text: Vue.prototype.$translate("selectTheTransactionAmount"),
    };
    const sortedEntries = this.sortDesc(value);
    let amountText = "";
    for (let i = 0; i < sortedEntries.length; i++) {
      amountText = Vue.filter("commaSep")(sortedEntries[i]);
      newOptions[i + 1] = {
        value: sortedEntries[i],
        text: amountText + " " + Vue.prototype.$translate("toman") + " ",
      };
    }
    return newOptions;
  },
};
